import { render } from "./changeCompanyModal.vue?vue&type=template&id=5a133c66&ts=true"
import script from "./changeCompanyModal.vue?vue&type=script&lang=ts"
export * from "./changeCompanyModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__